function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#cacdd9;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-205 -321)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 20,
  height: 20,
  transform: "translate(205 321)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(206 267.212)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 60.828)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M9.521,152.364a1.023,1.023,0,0,1-1.063,0L0,147.2v6.864a2.657,2.657,0,0,0,2.656,2.656H15.344A2.657,2.657,0,0,0,18,154.064V147.2Z",
  transform: "translate(0 -147.2)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.085 57.088)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M17.307,57.088H4.619a2.641,2.641,0,0,0-2.571,2.083l8.926,5.44,8.9-5.44A2.641,2.641,0,0,0,17.307,57.088Z",
  transform: "translate(-2.048 -57.088)"
})))));

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.86b9ebdd.svg";
export { ForwardRef as ReactComponent };